import axios from 'axios';
import type { PortalNotification } from './notificationHref';
import { getAuthToken, reportUnauthorized } from '@/lib/auth-utils';

const api = axios.create({ baseURL: process.env.NEXT_PUBLIC_API_BASE_URL });

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401 && getAuthToken()) {
      reportUnauthorized();
    }
    return Promise.reject(error);
  }
);

/**
 * Fetch the first 100 outstanding backend notifications.
 * @param token Existing Sanctum bearer token for the logged-in user.
 * @returns Notification records from the Laravel inbox response.
 */
export async function getNotifications(token: string): Promise<PortalNotification[]> {
  const response = await api.get('/api/notifications?per_page=100', {
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json', 'Cache-Control': 'no-cache' },
  });
  const data = response.data?.data;
  return Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];
}

/**
 * Delete one backend fallback after the user opens or marks it viewed.
 * @param id Backend notification id.
 * @param token Existing Sanctum bearer token for the logged-in user.
 */
export async function acknowledgeNotification(id: string, token: string): Promise<void> {
  await api.delete(`/api/notifications/${encodeURIComponent(id)}`, {
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
  });
}
